import { create } from "zustand";

/*
 * UI-store (ADR 0026 — client-state de INTERFACE).
 *
 * Regra dura: estado de UI SÓ em Zustand; dado de servidor SÓ em Query
 * (CP futuro). NÃO colocar tokens nem dados de auth aqui — sessão é o
 * `lib/auth/store.ts`.
 *
 * Como o store de sessão, é memory-only: sem persistência, sem rehidratação
 * (I1/I3). Reload = estado de UI volta ao default.
 */

/** Tema da interface. */
export type Tema = "claro" | "escuro";

interface EstadoUi {
  /** Navegação lateral aberta? */
  navAberta: boolean;
  /** Tema atual. */
  tema: Tema;

  /** Alterna a navegação lateral. */
  alternarNav: () => void;
  /** Define explicitamente o estado da navegação lateral. */
  definirNavAberta: (aberta: boolean) => void;
  /** Define o tema. */
  definirTema: (tema: Tema) => void;
}

export const useUiStore = create<EstadoUi>((set) => ({
  navAberta: true,
  tema: "claro",

  alternarNav: () => set((estado) => ({ navAberta: !estado.navAberta })),
  definirNavAberta: (aberta) => set({ navAberta: aberta }),
  definirTema: (tema) => set({ tema }),
}));
